import { gql } from '@apollo/client'

export const SAVE_FILTER = gql`
  mutation saveFilter($filter: savedFilterType!, $module: ModulesWithFilterEnum! = topics) {
    saveFilter(filter: $filter, module: $module) {
      id
      user_id
      workspace_id
      module
      filter {
        ... on SavedFilterTopics {
          age
          gender
          country
        }
      }
    }
  }
`

export const REMOVE_FILTER = gql`
  mutation removeFilter($id: String!) {
    removeFilter(id: $id) {
      message
      success
    }
  }
`
export const GET_WORKSPACE_SAVED_FILTERS = gql`
  query getWorkspaceSavedFilters($module: ModulesWithFilterEnum! = topics) {
    getWorkspaceSavedFilters(module: $module) {
      id
      module
      user_id
      workspace_id
      filter {
        ... on SavedFilterTopics {
          age
          country
          gender
        }
      }
    }
  }
`

export const SAVE_FILTER_LOCALSTORAGE = gql`
  mutation saveFilterBatch($filter: [savedFilterType!]!, $module: ModulesWithFilterEnum! = topics) {
    saveFilterBatch(filter: $filter, module: $module) {
      created_at
      id
      filter {
        ... on SavedFilterTopics {
          age
          country
          gender
        }
      }
    }
  }
`
